<!-- <button mat-button class="btn-action" style="position:fixed;top: 20px;right: 10px;z-index: 20;" (click)="openViewLanguages()"><img src="../assets/{{website_language}}.png" width="24px" alt=""></button> -->
<!-- <button mat-button class="btn-action" style="position:fixed;top: 20px;right: 10px;z-index: 20;" (click)="openViewLanguages()"><img src="../assets/translation.png" width="24px" alt=""></button> -->

<router-outlet></router-outlet>
<!-- <app-chatbot></app-chatbot> -->
<!-- THIS wAS CAUSING THE FREEZING -->
